/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class Quotes extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const backgroundColor = this.attrs.banner.visual()?.secondary_color?.default;

		if (!backgroundColor) {
			return null;
		}

		return (
			<span className="Quotes">
				<span className="BCQuote closing" style={{ '--banner-quotes-bg': backgroundColor }} />
			</span>
		);
	}
}
